import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getChannelConfig } from "config";
import AuthContextService from "contexts/authContext/AuthContextServices";
import jwtDecode from "jwt-decode";
import CoinsAPI from "../../../../../apiConfig/CoinsAPI";

export const status = {
  INITIAL: "INITIAL",
  LOADING: "LOADING",
  LOADED: "LOADED",
  EMPTY: "EMPTY",
  ERROR: "ERROR",
};

const initialState = {
  coins: null,
  status: status.INITIAL,
  errorMessage: null,
};

//Thunks
export const fetchAsyncCoins = createAsyncThunk(
  "coins/fetchAsyncCoins",
  async (_, { rejectWithValue }) => {
    try {
      const tokenObj = AuthContextService.getTokenFromLocalStorage();
      const { access_token } = JSON.parse(tokenObj);
      const { abcChainAccount } = jwtDecode(access_token);
      const abcCoinSymbol = getChannelConfig().abcCoinSymbol;
      const response = await CoinsAPI.get(
        `/${abcCoinSymbol}/balances/${abcChainAccount}`,
      );
      return {
        status: response.status,
        data: response.data,
      };
    } catch (err) {
      console.log(err);
      return rejectWithValue({
        status: err.response.status,
        data: err.response.data,
      });
    }
  },
);

//Slices
const CoinsSlice = createSlice({
  name: "coins",
  initialState,
  reducers: {
    resetCoins: (state, action) => {
      state.coins = null;
      state.status = status.INITIAL;
      state.errorMessage = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchAsyncCoins.pending, state => {
        state.errorMessage = null;
        state.status = status.LOADING;
      })
      .addCase(fetchAsyncCoins.fulfilled, (state, { payload }) => {
        if (payload.data === undefined) {
          state.status = status.ERROR;
          return;
        }

        if (payload.data.ABCCoin === 0) {
          state.status = status.EMPTY;
          state.coins = payload.data;
          return;
        }

        state.coins = payload.data;
        state.errorMessage = null;
        state.status = status.LOADED;
      })
      .addCase(fetchAsyncCoins.rejected, (state, { payload }) => {
        if (payload === undefined) {
          state.status = status.ERROR;
          return;
        }
        state.errorMessage = payload.data;
        state.status = status.ERROR;
      });
  },
});
export const { resetCoins } = CoinsSlice.actions;

export default CoinsSlice.reducer;
